//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.BaseSectionBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"Dim1",0,"Expression",0],[1,"Dim2",0,"Expression",0],[1,"Dim3",0,"Expression",0],[1,"Dim4",0,"Expression",0],[1,"Dim5",0,"Expression",0],[1,"Dim6",0,"Expression",0],[0,"SectionType",1,0]],[],[]];
SPLM.Motion.StandardSectionBuilder = class extends SPLM.Motion.BaseSectionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.StandardSectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.StandardSectionBuilder.StandardSectionType = Object.freeze({
    "Rod" : "Rod", "Tube" : "Tube", "Bar" : "Bar", "Box" : "Box", "Box1" : "Box1", "I" : "I", "I1" : "I1", "T" : "T", "T1" : "T1", "T2" : "T2", "Chan" : "Chan", "Chan1" : "Chan1", "Chan2" : "Chan2", "Hat" : "Hat", "Hat1" : "Hat1", "H" : "H", "L" : "L", "Z" : "Z", "Hexa" : "Hexa", "Cross" : "Cross"});

export default SPLM;